import { render, staticRenderFns } from "./DeviationDashboardAdditionalDetailsRow.vue?vue&type=template&id=797cd902&"
import script from "./DeviationDashboardAdditionalDetailsRow.vue?vue&type=script&lang=js&"
export * from "./DeviationDashboardAdditionalDetailsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports